import React, { FC } from 'react'

import { TRegion } from '@/entities/regions'

import { SPB_CITY_CODE } from '@/shared/lib/utils/constants/const'

import { defaultDeliveryInfo, deliveryPickUpInfo, spbDeliveryInfo, spbDeliveryInfoYur } from '../../data'

import { DeliveryInfoList } from './DeliveryInfoList/DeliveryInfoList'

import cl from './DeliveryInfoBlock.module.scss'

type DeliveryInfoBlockProps = {
	region: Pick<TRegion, 'REGION_CODE'>
	yurInfo?: boolean
	isModal?: boolean
}

export const DeliveryInfoBlock: FC<DeliveryInfoBlockProps> = ({ region, yurInfo = false, isModal }) => {
	return (
		<div className={cl.deliveryInfoBlock}>
			{(() => {
				switch (region.REGION_CODE) {
					case SPB_CITY_CODE:
						return (
							<>
								<DeliveryInfoList isModal={isModal} items={yurInfo ? spbDeliveryInfoYur : spbDeliveryInfo} />
								<DeliveryInfoList isModal={isModal} items={deliveryPickUpInfo} />
							</>
						)
					default:
						return (
							<>
								<DeliveryInfoList isModal={isModal} items={defaultDeliveryInfo} />
								<DeliveryInfoList isModal={isModal} items={deliveryPickUpInfo} />
							</>
						)
				}
			})()}
		</div>
	)
}
